<template>
	<div class="row" style="margin-top: 20px">
		<div class="col-xs-12">
			<flCabecalhoForm
				:msg="_traducao('global', 'obrigatorio')"
				cls="print-titulo-form-20"
				:texto="_traducao('global', 'dadosCadernetaIndividualVoos')"
			/>

			<div class="row">
				<div class="col-xs-12 col-md-4 form-group">
					<label
						><span class="no-print"></span
						>{{ _traducao('global', 'horasVooPrimeiroPilotoComando') }}:</label
					>
					<money
						v-model="form.horas_voo"
						class="form-control input-sm"
						v-bind="_vpercem(1)"
					></money>
				</div>

				<div class="col-xs-12 col-md-4 form-group">
					<label
						><span class="no-print"></span
						>{{ _traducao('global', 'horasVooSegundoPilotoComando') }}:</label
					>
					<money
						v-bind="_vpercem(1)"
						v-model="form.horas_voo_segundo"
						class="form-control input-sm"
					></money>
				</div>

				<div class="col-xs-12 col-md-4 form-group">
					<label>Data do último voo antes do sistema ser implementado:</label>
					<flDateTime
						style="margin-bottom: 5px"
						name="dataHorasVoo"
						@v-model="(val) => (form.data_horas_voo = val)"
						:value="form.data_horas_voo"
						:lang="_getLangDp"
						:format="_formatDate"
					/>
				</div>
				<!--
				<div class="col-xs-12 col-md-4 form-group">
					<label>{{_traducao('global', 'dataUltimoVoo')}}:</label>
					<flDateTime style="margin-bottom: 5px;"
								name="dataHorasVooSegundo"
								@v-model="(val) => form.data_horas_voo_segundo = val"
								:value="form.data_horas_voo_segundo"
								:lang="_getLangDp"
								:format="_formatDate"/>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			form: {
				horas_voo: '',
				horas_voo_segundo: '',
				data_horas_voo: '',
				data_horas_voo_segundo: ''
			}
		}
	},

	methods: {
		editar(item) {
			this.form.horas_voo = Number(item.horas_voo).toFixed(1)
			this.form.horas_voo_segundo = Number(item.horas_voo_segundo).toFixed(1)
			this.form.data_horas_voo = item.data_horas_voo
			this.form.data_horas_voo_segundo = item.data_horas_voo_segundo
		},

		validaForm() {
			this.$emit('dados-civ', this.form)
		}
	}
}
</script>